export default "__VITE_ASSET__Bkm4r$Ow__"